var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _circle2, _g, _path19, _path20, _path21, _circle3, _circle4, _g2, _circle5, _circle6, _g3, _circle7, _circle8, _g4, _path22, _path23, _path24, _path25, _circle9, _circle10, _g5, _circle11, _circle12, _g6, _circle13, _circle14, _g7, _circle15, _circle16, _g8, _circle17, _circle18, _g9, _circle19, _circle20, _g10, _circle21, _circle22, _g11, _circle23, _circle24, _g12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1047,
    height: 531,
    viewBox: "0 0 1047 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5312 27.8076L969.531 27.8077",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.53125 100.808L1046.53 100.808",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5312 172.808H1046.53",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.53125 245.808H1046.53",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5312 317.808H969.531",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M954.533 389.066H687.984M120.559 390.544H265.533",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.531 520.808L123.531 0.807617",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.852 423.721L195.852 0.808075",
    stroke: "#9FDEB2",
    strokeOpacity: 0.66,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.258 455.721V0.808075",
    stroke: "#9FDEB2",
    strokeOpacity: 0.66,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M340.531 368.808L340.531 28.8076",
    stroke: "#9FDEB2",
    strokeOpacity: 0.66,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M413.531 368.808L413.531 0.807614",
    stroke: "#9FDEB2",
    strokeOpacity: 0.66,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M485.531 368.808L485.531 28.8076",
    stroke: "#9FDEB2",
    strokeOpacity: 0.66,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M557.531 368.808L557.531 28.8076",
    stroke: "#9FDEB2",
    strokeOpacity: 0.66,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M630.531 368.808L630.531 28.8076",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M702.531 465.955L702.531 9.80753",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M775.109 530.639V29.7537",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M847.531 475.278V9.42816",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M919.941 530.368V9.41888",
    stroke: "#9FDEB2",
    strokeOpacity: 0.88,
    strokeWidth: 0.65825,
    strokeLinecap: "square",
    strokeDasharray: "3.29 3.29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195.531,
    cy: 318.808,
    r: 28,
    fill: "#F3FFF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.531,
    cy: 318.808,
    r: 31.3,
    fill: "#F3FFF0",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "4.2 4.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196.015,
    cy: 319.292,
    r: 23.4839,
    fill: "#EAFDE8"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M191.163 327.141H199.897C202.197 327.141 203.113 325.733 203.222 324.016L203.655 317.133C203.772 315.333 202.338 313.808 200.53 313.808C200.022 313.808 199.555 313.516 199.322 313.066L198.722 311.858C198.338 311.1 197.338 310.475 196.488 310.475H194.58C193.722 310.475 192.722 311.1 192.338 311.858L191.738 313.066C191.505 313.516 191.038 313.808 190.53 313.808C188.722 313.808 187.288 315.333 187.405 317.133L187.838 324.016C187.938 325.733 188.863 327.141 191.163 327.141Z",
    stroke: "#9FDEB2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.281 315.475H196.781",
    stroke: "#9FDEB2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M195.533 323.807C197.024 323.807 198.241 322.591 198.241 321.099C198.241 319.607 197.024 318.391 195.533 318.391C194.041 318.391 192.824 319.607 192.824 321.099C192.824 322.591 194.041 323.807 195.533 323.807Z",
    stroke: "#9FDEB2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.53,
    cy: 245.808,
    r: 7.22581,
    fill: "#F3FFF0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.531,
    cy: 245.808,
    r: 8.3,
    fill: "#FBFFFA",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "3.2 3.2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 195.531,
    cy: 245.808,
    r: 5,
    fill: "#EFFEF3"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.53,
    cy: 390.808,
    r: 7.22581,
    fill: "#F3FFF0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.531,
    cy: 390.808,
    r: 8.3,
    fill: "#F8FFF7",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "3.2 3.2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 195.531,
    cy: 390.808,
    r: 5,
    fill: "#EAFDE8"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 172.808,
    r: 28,
    fill: "#F3FFF0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 172.808,
    r: 31.3,
    fill: "#F3FFF0",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "4.2 4.2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 172.807,
    r: 23.4839,
    fill: "#EBFDE7"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M919.531 178.641C922.29 178.641 924.531 176.4 924.531 173.641V169.475C924.531 166.716 922.29 164.475 919.531 164.475C916.773 164.475 914.531 166.716 914.531 169.475V173.641C914.531 176.4 916.773 178.641 919.531 178.641Z",
    stroke: "#9FDEB2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M912.031 171.975V173.641C912.031 177.783 915.39 181.141 919.531 181.141C923.673 181.141 927.031 177.783 927.031 173.641V171.975",
    stroke: "#9FDEB2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M917.121 169.041C918.604 168.499 920.221 168.499 921.704 169.041",
    stroke: "#9FDEB2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M917.891 171.541C918.891 171.266 919.949 171.266 920.949 171.541",
    stroke: "#9FDEB2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 100.808,
    r: 7.22581,
    fill: "#F3FFF0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 100.808,
    r: 8.3,
    fill: "#FCFFFC",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "3.2 3.2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 100.808,
    r: 6,
    fill: "#EAFEE4"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 245.808,
    r: 7.22581,
    fill: "#F3FFF0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 245.808,
    r: 8.3,
    fill: "#FEFFFE",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "3.2 3.2"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 919.531,
    cy: 245.808,
    r: 6,
    fill: "#ECFFEA"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.531,
    cy: 317.808,
    r: 28,
    transform: "rotate(-90 776.531 317.808)",
    fill: "#F3FFF0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.531,
    cy: 317.808,
    r: 31.3,
    transform: "rotate(-90 776.531 317.808)",
    fill: "#F3FFF0",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "4.2 4.2"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 776.531,
    cy: 317.808,
    r: 23.4839,
    transform: "rotate(-90 776.531 317.808)",
    fill: "#EAFDE8"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 702.531,
    cy: 317.807,
    r: 7.22581,
    transform: "rotate(-90 702.531 317.807)",
    fill: "#F3FFF0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 702.531,
    cy: 317.808,
    r: 8.3,
    transform: "rotate(-90 702.531 317.808)",
    fill: "#FEFFFE",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "3.2 3.2"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 702.531,
    cy: 317.808,
    r: 6,
    transform: "rotate(-90 702.531 317.808)",
    fill: "#ECFFEA"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.531,
    cy: 317.807,
    r: 7.22581,
    transform: "rotate(-90 847.531 317.807)",
    fill: "#F3FFF0"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.531,
    cy: 317.808,
    r: 8.3,
    transform: "rotate(-90 847.531 317.808)",
    fill: "#FEFFFE",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "3.2 3.2"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 847.531,
    cy: 317.808,
    r: 6,
    transform: "rotate(-90 847.531 317.808)",
    fill: "#ECFFEA"
  }))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.531,
    cy: 100.808,
    r: 28,
    transform: "rotate(-90 123.531 100.808)",
    fill: "#F3FFF0"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.531,
    cy: 100.808,
    r: 31.3,
    transform: "rotate(-90 123.531 100.808)",
    fill: "#F3FFF0",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "4.2 4.2"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.531,
    cy: 100.808,
    r: 23.4839,
    transform: "rotate(-90 123.531 100.808)",
    fill: "#EAFDE8"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5305,
    cy: 100.807,
    r: 7.22581,
    transform: "rotate(-90 49.5305 100.807)",
    fill: "#F3FFF0"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5312,
    cy: 100.808,
    r: 8.3,
    transform: "rotate(-90 49.5312 100.808)",
    fill: "#FEFFFE",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "3.2 3.2"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.5312,
    cy: 100.808,
    r: 6,
    transform: "rotate(-90 49.5312 100.808)",
    fill: "#ECFFEA"
  }))), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.53,
    cy: 100.807,
    r: 7.22581,
    transform: "rotate(-90 194.53 100.807)",
    fill: "#F3FFF0"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.531,
    cy: 100.808,
    r: 8.3,
    transform: "rotate(-90 194.531 100.808)",
    fill: "#FEFFFE",
    stroke: "#BDEBC7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeDasharray: "3.2 3.2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_3265_301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 194.531,
    cy: 100.808,
    r: 6,
    transform: "rotate(-90 194.531 100.808)",
    fill: "#ECFFEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3265_301",
    x: 171.628,
    y: 294.904,
    width: 48.7752,
    height: 48.7742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3265_301",
    x: 189.628,
    y: 239.904,
    width: 11.8065,
    height: 11.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3265_301",
    x: 189.628,
    y: 384.904,
    width: 11.8065,
    height: 11.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3265_301",
    x: 895.144,
    y: 148.42,
    width: 48.7752,
    height: 48.7742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3265_301",
    x: 912.628,
    y: 93.9044,
    width: 13.8065,
    height: 13.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3265_301",
    x: 912.628,
    y: 238.904,
    width: 13.8065,
    height: 13.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3265_301",
    x: 752.144,
    y: 293.421,
    width: 48.7752,
    height: 48.7742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3265_301",
    x: 695.628,
    y: 310.904,
    width: 13.8065,
    height: 13.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3265_301",
    x: 840.628,
    y: 310.904,
    width: 13.8065,
    height: 13.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_3265_301",
    x: 99.1436,
    y: 76.421,
    width: 48.7752,
    height: 48.7742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_3265_301",
    x: 42.628,
    y: 93.9044,
    width: 13.8065,
    height: 13.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_3265_301",
    x: 187.628,
    y: 93.9044,
    width: 13.8065,
    height: 13.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.451613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856221 0 0 0 0 0.970833 0 0 0 0 0.833299 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3265_301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3265_301",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.c881005c9866ea84777358954818bae0.svg";
export { ForwardRef as ReactComponent };